import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white shadow container rounded-2xl py-4 justify-between items-start h-full min-h-screen mt-3 lg:mt-0" }
const _hoisted_2 = { class: "space-y-3 p-3 w-full" }
const _hoisted_3 = { class: "lg:space-y-4 space-y-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Services", -1)
const _hoisted_5 = { class: "lg:grid lg:grid-cols-2 lg:gap-2 flex flex-col" }
const _hoisted_6 = { class: "space-x-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Managed job status", -1)
const _hoisted_8 = {
  key: 0,
  class: "text-sm font-extralight text-orange-400"
}
const _hoisted_9 = {
  key: 1,
  class: "text-sm font-extralight text-green-500"
}
const _hoisted_10 = {
  key: 2,
  class: "text-sm font-extralight text-red-400"
}
const _hoisted_11 = {
  key: 0,
  class: "space-x-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Actions", -1)
const _hoisted_13 = { class: "lg:grid lg:grid-cols-2 lg:gap-2 flex flex-col" }
const _hoisted_14 = { class: "space-x-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "AI Talent Matching", -1)
const _hoisted_16 = { class: "space-x-4 mt-3 lg:mt-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Job type", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_19 = { class: "space-y-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Department Details", -1)
const _hoisted_21 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_22 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Department", -1)
const _hoisted_24 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Internal Code", -1)
const _hoisted_26 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Company", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_29 = { class: "space-y-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Location", -1)
const _hoisted_31 = { class: "flex flex-col lg:flex-row items-center justify-between" }
const _hoisted_32 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Country", -1)
const _hoisted_34 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Region or City ", -1)
const _hoisted_36 = { class: "flex flex-row items-center w-full lg:justify-end" }
const _hoisted_37 = {
  key: 0,
  class: "lg:px-7 lg:p-5 sm:p-2 text-primary-dark bg-primary-light text-xs rounded capitalize-letter"
}
const _hoisted_38 = {
  key: 1,
  class: "text-primary text-sm"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_40 = { class: "space-y-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Job Information", -1)
const _hoisted_42 = { class: "space-y-3 block" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400 block" }, "Description", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_45 = { class: "space-y-3 block" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400 block" }, "Requirements", -1)
const _hoisted_47 = {
  key: 0,
  class: "list-disc p-3"
}
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = {
  key: 1,
  class: "text-primary-dark text-sm font-extralight block"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_51 = { class: "space-y-3 block" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400 block" }, "Responsibilities", -1)
const _hoisted_53 = {
  key: 0,
  class: "list-disc p-3"
}
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = {
  key: 1,
  class: "text-primary-dark text-sm font-extralight block"
}
const _hoisted_56 = { class: "job_comment_section" }
const _hoisted_57 = {
  key: 0,
  class: "py-2"
}
const _hoisted_58 = { class: "grid justify-items-end py-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_60 = { class: "space-y-3 block" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400 block" }, "Benefits", -1)
const _hoisted_62 = {
  key: 0,
  class: "list-disc p-3"
}
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = {
  key: 1,
  class: "text-primary-dark text-sm font-extralight block"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_66 = { class: "space-y-4" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Company Industry and Job Function", -1)
const _hoisted_68 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_69 = { class: "flex flex-row w-full space-x-8 items-center py-3" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Industry", -1)
const _hoisted_71 = { class: "flex flex-row w-full space-x-8 items-center py-3" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Job Function", -1)
const _hoisted_73 = { class: "job_comment_section" }
const _hoisted_74 = { class: "py-2" }
const _hoisted_75 = { class: "grid justify-items-end py-2" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_78 = { class: "space-y-4" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Employment Details ", -1)
const _hoisted_80 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_81 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Employment Type", -1)
const _hoisted_83 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Experience", -1)
const _hoisted_85 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Education", -1)
const _hoisted_87 = { class: "job_comment_section" }
const _hoisted_88 = { class: "py-2" }
const _hoisted_89 = { class: "grid justify-items-end py-2" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_92 = { class: "flex flex-col" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold py-2" }, "Skills", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 mb-2 font-normal" }, "Required", -1)
const _hoisted_95 = {
  key: 0,
  class: "w-full flex flex-wrap content-center"
}
const _hoisted_96 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_97 = {
  key: 2,
  class: "mt-5 text-gray-400 mb-2 font-normal"
}
const _hoisted_98 = { class: "w-full flex flex-wrap content-center" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_100 = { class: "space-y-4" }
const _hoisted_101 = { class: "block text-lg font-bold" }
const _hoisted_102 = { class: "text-gray-500 font-semibold" }
const _hoisted_103 = { class: "flex flex-row items-center" }
const _hoisted_104 = { class: "flex flex-col lg:flex-row w-full space-x-4 items-center py-3" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "From", -1)
const _hoisted_106 = { class: "text-sm font-extralight" }
const _hoisted_107 = { class: "flex flex-col lg:flex-row w-full space-x-4 items-center py-3" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "To", -1)
const _hoisted_109 = { class: "text-sm font-extralight" }
const _hoisted_110 = { class: "flex flex-col lg:flex-row w-full space-x-4 items-center py-3" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Currency", -1)
const _hoisted_112 = { class: "text-sm font-extralight" }
const _hoisted_113 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_114 = { class: "flex flex-col lg:flex-row w-full space-x-4 items-center py-3" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "From", -1)
const _hoisted_116 = { class: "text-sm font-extralight" }
const _hoisted_117 = { class: "flex flex-col lg:flex-row w-full space-x-4 items-center py-3" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "To", -1)
const _hoisted_119 = { class: "text-sm font-extralight" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col lg:flex-row w-full space-x-4 py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Currency"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight" }, " USD ")
], -1)
const _hoisted_121 = { class: "job_comment_section" }
const _hoisted_122 = { class: "py-2" }
const _hoisted_123 = { class: "grid justify-items-end py-2" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("strong", null, "Warning: ", -1)
const _hoisted_128 = /*#__PURE__*/_createTextVNode("This action can not be undone.")
const _hoisted_129 = [
  _hoisted_127,
  _hoisted_128
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_TimeLine = _resolveComponent("TimeLine")!
  const _component_Button = _resolveComponent("Button")!
  const _component_JobCommentForm = _resolveComponent("JobCommentForm")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (_ctx.data.job_status === 'pending_approval')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " pending approval "))
                : _createCommentVNode("", true),
              (_ctx.data.job_status === 'published' && _ctx.data.is_managed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Active "))
                : _createCommentVNode("", true),
              (!_ctx.data.is_managed && _ctx.data.job_status !== 'pending_approval')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Inactive "))
                : _createCommentVNode("", true)
            ]),
            (
              _ctx.data.job_status === 'pending_approval' &&
              _ctx.profile.roles.includes('sourcing_admin')
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("button", {
                    class: _normalizeClass(["text-xs mr-4", {
                'text-gray-500 hover:text-gray-400':
                  _ctx.data.job_status !== 'pending_approval',
                'text-green-500 hover:text-green-600':
                  _ctx.data.job_status === 'pending_approval',
              }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.managedJobActions(true)))
                  }, " Accept ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["text-xs", {
                'text-gray-500 hover:text-gray-400':
                  _ctx.data.job_status !== 'pending_approval',
                'text-red-500 hover:text-red-600':
                  _ctx.data.job_status === 'pending_approval',
              }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.managedJobActions(false)))
                  }, " Decline ", 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight", {
                'text-green-500': _ctx.data.match_candidates,
                'text-red-400': !_ctx.data.match_candidates,
              }])
              }, _toDisplayString(_ctx.data.match_candidates ? "On" : "Off"), 3)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight", { 'text-primary-purple': _ctx.data.is_confidential }])
              }, _toDisplayString(_ctx.data.is_confidential ? "Confidential" : "Public"), 3)
            ])
          ])
        ]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight capitalize", _ctx.data && !_ctx.data.department && 'text-primary-dark'])
              }, _toDisplayString(_ctx.data && _ctx.data.department ? _ctx.data.department : _ctx.labelNoInfo), 3)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight", _ctx.data && !_ctx.data.department_code && 'text-primary-dark'])
              }, _toDisplayString(_ctx.data && _ctx.data.department_code
                  ? _ctx.data.department_code
                  : _ctx.labelNoInfo), 3)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight", _ctx.data && !_ctx.data.company && 'text-primary-dark'])
              }, _toDisplayString(_ctx.data && _ctx.data.company ? _ctx.data.company.visible_name : _ctx.labelNoInfo), 3)
            ])
          ])
        ]),
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight", 
                _ctx.data &&
                !_ctx.data.job_location?.location?.country &&
                'text-primary-dark'
              ])
              }, _toDisplayString(_ctx.data && _ctx.data.job_location?.location?.country
                  ? _ctx.data.job_location?.location?.country
                  : _ctx.labelNoInfo), 3)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight", 
                _ctx.data && !_ctx.data.job_location?.location.city && 'text-primary-dark'
              ])
              }, _toDisplayString(_ctx.data && _ctx.data.job_location?.location?.city
                  ? _ctx.data.job_location?.location.city +
                    ", " +
                    _ctx.data.job_location?.location.state
                  : _ctx.labelNoInfo), 3)
            ]),
            _createElementVNode("div", _hoisted_36, [
              (_ctx.data.work_type)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.data.work_type.replaceAll("_", " ")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_38, " Preferred work type no added "))
            ])
          ])
        ]),
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight block", _ctx.data && _ctx.data.description === '' && 'text-primary-dark'])
            }, _toDisplayString(_ctx.data && _ctx.data.description !== ""
                ? _ctx.data.description
                : "No information"), 3)
          ]),
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            (_ctx.data && _ctx.data.requirements !== '<li></li>')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_47, [
                  _createElementVNode("span", {
                    class: "text-sm font-extralight block",
                    innerHTML: _ctx.data.requirements
                  }, null, 8, _hoisted_48)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_49, "No information"))
          ]),
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            (_ctx.data && _ctx.data.responsabilities !== '<li></li>')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_53, [
                  _createElementVNode("span", {
                    class: "text-sm font-extralight block",
                    innerHTML: _ctx.data.responsabilities
                  }, null, 8, _hoisted_54)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_55, "No information")),
            _createElementVNode("div", _hoisted_56, [
              (_ctx.infoCommentStore && _ctx.infoCommentStore.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    (_ctx.loadingTimeline)
                      ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_TimeLine, {
                          key: 1,
                          timeline: _ctx.infoCommentStore
                        }, null, 8, ["timeline"]))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_Button, {
                  label: _ctx.expand.comment_info ? 'Close' : 'Add a comment',
                  variant: "",
                  onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expand.comment_info = !_ctx.expand.comment_info))
                }, {
                  startIcon: _withCtx(() => [
                    _hoisted_59
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_JobCommentForm, {
                  section: "job_info",
                  onGetDescriptionComments: _cache[3] || (_cache[3] = ($event: any) => (
                  _ctx.getCommentsBySection('getInfoComments')
                ))
                })
              ], 512), [
                [_vShow, _ctx.expand.comment_info]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            (_ctx.data && _ctx.data.job_benefits !== '<li></li>')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_62, [
                  _createElementVNode("span", {
                    class: "text-sm font-extralight block",
                    innerHTML: _ctx.data.job_benefits
                  }, null, 8, _hoisted_63)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_64, "No information"))
          ])
        ]),
        _hoisted_65,
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight", 
                _ctx.companyIndustryProfile &&
                !_ctx.companyIndustryProfile.name &&
                'text-primary-dark'
              ])
              }, _toDisplayString(_ctx.companyIndustryProfile && _ctx.companyIndustryProfile.name
                  ? _ctx.companyIndustryProfile.name
                  : _ctx.labelNoInfo), 3)
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight", _ctx.data && !_ctx.data?.job_function?.name && 'text-primary-dark'])
              }, _toDisplayString(_ctx.data && _ctx.data.job_function && _ctx.data.job_function.name
                  ? _ctx.data.job_function.name
                  : _ctx.labelNoInfo), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              (_ctx.loadingTimeline)
                ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
                : (_openBlock(), _createBlock(_component_TimeLine, {
                    key: 1,
                    timeline: _ctx.functionCommentStore
                  }, null, 8, ["timeline"]))
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createVNode(_component_Button, {
                label: _ctx.expand.comment_function ? 'Close' : 'Add a comment',
                variant: "",
                onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expand.comment_function = !_ctx.expand.comment_function))
              }, {
                startIcon: _withCtx(() => [
                  _hoisted_76
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_JobCommentForm, {
                section: 'job_function',
                onGetDescriptionComments: _cache[5] || (_cache[5] = ($event: any) => (
                _ctx.getCommentsBySection('getFunctionComments')
              ))
              })
            ], 512), [
              [_vShow, _ctx.expand.comment_function]
            ])
          ])
        ]),
        _hoisted_77,
        _createElementVNode("div", _hoisted_78, [
          _hoisted_79,
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight capitalize", _ctx.data && !_ctx.data?.employment_type && 'text-primary-dark'])
              }, _toDisplayString(_ctx.data && _ctx.data?.employment_type
                  ? _ctx.replaceEnum(_ctx.data?.employment_type)
                  : _ctx.labelNoInfo), 3)
            ]),
            _createElementVNode("div", _hoisted_83, [
              _hoisted_84,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight capitalize", _ctx.data && !_ctx.data?.experience && 'text-primary-dark'])
              }, _toDisplayString(_ctx.data && _ctx.data?.experience
                  ? _ctx.replaceEnum(_ctx.data?.experience)
                  : _ctx.labelNoInfo), 3)
            ]),
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-extralight capitalize", _ctx.data && !_ctx.data?.education && 'text-primary-dark'])
              }, _toDisplayString(_ctx.data && _ctx.data?.education
                  ? _ctx.replaceEnum(_ctx.data?.education)
                  : _ctx.labelNoInfo), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              (_ctx.loadingTimeline)
                ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
                : (_openBlock(), _createBlock(_component_TimeLine, {
                    key: 1,
                    timeline: _ctx.detailsCommentStore
                  }, null, 8, ["timeline"]))
            ]),
            _createElementVNode("div", _hoisted_89, [
              _createVNode(_component_Button, {
                label: _ctx.expand.comment_details ? 'Close' : 'Add a comment',
                variant: "",
                onOnClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.expand.comment_details = !_ctx.expand.comment_details))
              }, {
                startIcon: _withCtx(() => [
                  _hoisted_90
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_JobCommentForm, {
                section: 'job_details',
                onGetDescriptionComments: _cache[7] || (_cache[7] = ($event: any) => (
                _ctx.getCommentsBySection('getDetailsComments')
              ))
              })
            ], 512), [
              [_vShow, _ctx.expand.comment_details]
            ])
          ])
        ]),
        _hoisted_91,
        _createElementVNode("div", _hoisted_92, [
          _hoisted_93,
          _hoisted_94,
          (_ctx.data.required_skills.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.required_skills, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "chip flex items-center mx-1 rounded-lg px-2 py-1 text-md bg-primary-light text-primary-dark",
                    key: index
                  }, _toDisplayString(item.name), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_96, "Not required skills in this job.")),
          (_ctx.data.optional_skills.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_97, "Nice to have"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_98, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.optional_skills, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "chip flex items-center mx-1 rounded-lg px-2 py-1 text-md bg-primary-light text-primary-dark",
                key: index
              }, _toDisplayString(item.name), 1))
            }), 128))
          ])
        ]),
        _hoisted_99,
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("span", _hoisted_101, [
            _createTextVNode(_toDisplayString(_ctx.data && _ctx.data.show_monthly_salary
              ? "Monthly Salary"
              : "Annual Salary") + " ", 1),
            _createElementVNode("span", _hoisted_102, "(" + _toDisplayString(_ctx.data.salary_type === "bruto" ? "Gross Salary" : "Net Salary") + ")", 1)
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _hoisted_105,
              _createElementVNode("span", _hoisted_106, _toDisplayString(`$${
                  _ctx.data && _ctx.data.salary_min
                    ? _ctx.numberWithCommas(
                        parseInt(
                          _ctx.data.show_monthly_salary
                            ? _ctx.data.salary_min.to_show
                            : _ctx.data.salary_min.annual,
                          10
                        )
                      )
                    : "0"
                }`), 1)
            ]),
            _createElementVNode("div", _hoisted_107, [
              _hoisted_108,
              _createElementVNode("span", _hoisted_109, _toDisplayString(`$${
                  _ctx.data && _ctx.data.salary_max
                    ? _ctx.numberWithCommas(
                        parseInt(
                          _ctx.data.show_monthly_salary
                            ? _ctx.data.salary_max.to_show
                            : _ctx.data.salary_max.annual,
                          10
                        )
                      )
                    : "0"
                }`), 1)
            ]),
            _createElementVNode("div", _hoisted_110, [
              _hoisted_111,
              _createElementVNode("span", _hoisted_112, _toDisplayString(`${_ctx.data && _ctx.data.currency_salary ? _ctx.data.currency_salary : "-"}`), 1)
            ])
          ]),
          (_ctx.data && _ctx.data.currency_salary && _ctx.data.currency_salary !== 'USD')
            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                _createElementVNode("div", _hoisted_114, [
                  _hoisted_115,
                  _createElementVNode("span", _hoisted_116, _toDisplayString(`$${
                  _ctx.data && _ctx.data.salary_min
                    ? _ctx.numberWithCommas(
                        parseInt(_ctx.data.salary_min.to_show_usd, 10)
                      )
                    : "0"
                }`), 1)
                ]),
                _createElementVNode("div", _hoisted_117, [
                  _hoisted_118,
                  _createElementVNode("span", _hoisted_119, _toDisplayString(`$${
                  _ctx.data && _ctx.data.salary_max
                    ? _ctx.numberWithCommas(
                        parseInt(_ctx.data.salary_max.to_show_usd, 10)
                      )
                    : "0"
                }`), 1)
                ]),
                _hoisted_120
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_121, [
            _createElementVNode("div", _hoisted_122, [
              (_ctx.loadingTimeline)
                ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
                : (_openBlock(), _createBlock(_component_TimeLine, {
                    key: 1,
                    timeline: _ctx.salaryCommentStore
                  }, null, 8, ["timeline"]))
            ]),
            _createElementVNode("div", _hoisted_123, [
              _createVNode(_component_Button, {
                label: _ctx.expand.comment_salary ? 'Close' : 'Add a comment',
                variant: "",
                onOnClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.expand.comment_salary = !_ctx.expand.comment_salary))
              }, {
                startIcon: _withCtx(() => [
                  _hoisted_124
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_JobCommentForm, {
                section: 'job_salary',
                onGetDescriptionComments: _cache[9] || (_cache[9] = ($event: any) => (
                _ctx.getCommentsBySection('getSalaryComments')
              ))
              })
            ], 512), [
              [_vShow, _ctx.expand.comment_salary]
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_base_modal, { visible: _ctx.showConfirmationModal }, {
      "alert-text": _withCtx(() => [
        (_ctx.managedJobConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_125, " When a managed job is added to your account, " + _toDisplayString(_ctx.profile.company.company_country.short_code === "MX"
            ? _ctx.pricing.managed_job + " " + _ctx.pricing.currency
            : _ctx.pricing.managed_job + " " + _ctx.pricing.currency) + " will be added to bill next cycle. ", 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_126, _hoisted_129))
      ]),
      actions: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn-outline-sm flex flex-row items-center disabled:opacity-50 justify-between px-4 py-2 text-primary truncate sm:text-base border-2 rounded-full transition duration-150 ease-in",
          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(false)), ["prevent"]))
        }, " Cancel "),
        _createElementVNode("button", {
          class: "btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in",
          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(true)), ["prevent"]))
        }, " Confirm ")
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}